"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKER = exports.WEBHOOK = exports.VALIDATE = exports.TEST = exports.SUPPLEMENT = exports.STAT = exports.SMS = exports.SLACK = exports.SEGMENT = exports.REFERRAL = exports.PROCESS = exports.ORGANIZATION = exports.NOTIFICATION = exports.NLP = exports.MESSAGE = exports.MERIDIAN_LINK = exports.LEAD = exports.JOB = exports.HTTP = exports.GENERAL = exports.FRONTEND = exports.FILER = exports.FILE = exports.EVENT = exports.EMAIL = exports.DONATIONS = exports.DOCUMENT = exports.DOCKET = exports.DOCKET_ALARM = exports.DOCASSEMBLE = exports.DEBTORCC = exports.CRON = exports.CASE = exports.AWS = exports.AUTH = exports.ATTORNEY = void 0;
exports.ATTORNEY = "attorney";
exports.AUTH = "auth";
exports.AWS = "aws";
exports.CASE = "case";
exports.CRON = "cron";
exports.DEBTORCC = "debtorcc";
exports.DOCASSEMBLE = "docassemble";
exports.DOCKET_ALARM = "docketAlarm";
exports.DOCKET = "docket";
exports.DOCUMENT = "document";
exports.DONATIONS = "donations";
exports.EMAIL = "email";
exports.EVENT = "event";
exports.FILE = "file";
exports.FILER = "filer";
exports.FRONTEND = "frontend";
exports.GENERAL = "general";
exports.HTTP = "http";
exports.JOB = "job";
exports.LEAD = "lead";
exports.MERIDIAN_LINK = "meridianLink";
exports.MESSAGE = "message";
exports.NLP = "nlp";
exports.NOTIFICATION = "notification";
exports.ORGANIZATION = "organization";
exports.PROCESS = "process";
exports.REFERRAL = "referral";
exports.SEGMENT = "segment";
exports.SLACK = "slack";
exports.SMS = "sms";
exports.STAT = "stat";
exports.SUPPLEMENT = "supplement";
exports.TEST = "test";
exports.VALIDATE = "validate";
exports.WEBHOOK = "webhook";
exports.WORKER = "worker";